import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { StockDocument } from "../models"
import { FromReferencePayload, InventoryAdjustmentPayload, PostPayload, QuickCreatePayload } from "./types"

export class Service {
    static post(payload: PostPayload) {
        return AppContext.getApiClient().post("/stock-documents", payload)
    }

    static createFromReference(payload: FromReferencePayload) {
        return AppContext.getApiClient().post("/stock-documents/create-from-reference", payload)
    }

    static get(id: string) {
        return AppContext.getApiClient().get(`/stock-documents/${id}`)
    }

    static delete(id: string) {
        return AppContext.getApiClient().delete(`/stock-documents/${id}`)
    }

    static unarchive(id: string) {
        return AppContext.getApiClient().put(`/stock-documents/${id}/unarchive`)
    }

    static markAsDone(id: string) {
        return AppContext.getApiClient().post(`/stock-documents/${id}/mark-as-done`)
    }

    static inventoryAdjustmentItemMovement(id:string, payload: InventoryAdjustmentPayload): Promise<StockDocument> {
        return AppContext.getApiClient().post(`/stock-documents/${id}/inventory-adjustment`, payload)
    }

    static quickCreateStockDocument(payload: QuickCreatePayload) {
        return AppContext.getApiClient().post("/stock-documents/quick-create", payload)
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/services/service.ts